// extracted by mini-css-extract-plugin
module.exports = {"title":"WeeklyGraphs_title__2xj41"};